import { navigate } from "gatsby";
import * as linksEN from "./src/locales/en/links.json";
import * as linksPL from "./src/locales/pl/links.json";
import * as linksCS from "./src/locales/cs/links.json";
import * as linksSK from "./src/locales/sk/links.json";
import * as linksAR from "./src/locales/ar/links.json";
import { getCurrentLang } from "./src/utils/getCurrentLang";

const links = {
  en: linksEN,
  pl: linksPL,
  cs: linksCS,
  sk: linksSK,
  ar: linksAR
};

export const onInitialClientRender = () => {
  // Check for url param "lang=xx" to override preferred language
  // This is important for enforcing a language even if it's not on the switcher
  const urlParams = new URLSearchParams(window.location.search);
  const urlLang = urlParams.get("lang");
  if (urlLang) {
    localStorage.setItem("preferred_lang", urlLang);
  }

  // Process preferred language from localStorage
  const selectedPreferredLang = localStorage.getItem("preferred_lang");

  if (sessionStorage.getItem("redirected") && !selectedPreferredLang) {
    return;
  }

  const userLang = navigator.language || navigator.userLanguage;
  const pathname = window.location.pathname;
  const currentLang = getCurrentLang(pathname);
  const preferredLang = selectedPreferredLang ?? userLang.split("-")[0];
  const keyLang = Object.entries(links[currentLang]).find(
    ([_, value]) => value === pathname
  )?.[0];

  if (preferredLang !== currentLang) {
    sessionStorage.setItem("redirected", "true");

    if (links[preferredLang][keyLang]) {
      navigate(links[preferredLang][keyLang], { replace: true });
    }
  }
};
